import classNames from 'classnames';
import { MediaModel } from 'lib/model/objects/mediaModel';
import { LayoutModel } from 'lib/model/objects/layoutModel';
import { OrderImage } from 'lib/orders/images';
import { Layout } from 'lib/types/layout';
import ImageEditorOrUploader from './ImageEditorOrUploader';

type NewOrderImageEditorProps = {
  position: 'top' | 'bottom';
  orderImages: (OrderImage | null)[];
  mediaList: MediaModel[] | null;
  insertImageAtIndex: (index: number, newOrderImage: OrderImage) => void;
  removeImageAtIndex: (index: number) => void;
  layout: Layout;
  disableEditing?: boolean;
  advertiserLogo?: string;
};
export function NewOrderImageEditor({
  position,
  orderImages,
  mediaList,
  insertImageAtIndex,
  removeImageAtIndex,
  layout,
  disableEditing,
  advertiserLogo
}: NewOrderImageEditorProps) {
  const layoutModel = new LayoutModel(layout);
  const { imageConfig } = layoutModel;
  /**
   * NOTE: We need to map rather than filter here to maintain the correct indexes for images in the given position.
   * Filtering alone would change the indexes and cause issues when updating/removing images.
   */
  const imageConfigsInPosition =
    imageConfig.map(image => {
      if (image.position === position) {
        return image;
      }

      return null;
    }) || [];

  if (imageConfigsInPosition.filter(Boolean).length === 0) {
    return null;
  }

  return (
    <div
      className={classNames({
        'flex gap-4': layout.photoAlignment === 'center'
      })}
    >
      {imageConfigsInPosition.map((imageConfig, index) => {
        if (!imageConfig) {
          return null;
        }

        const currentImage = orderImages[index];

        return (
          <div
            key={index}
            style={{
              width: layout.photoWidth === 'none' ? '100%' : layout.photoWidth
            }}
            className={classNames({
              'inline-block relative z-10 bg-white float-right border-dashed border-b border-l p-2':
                layout.photoAlignment !== 'center'
            })}
          >
            <ImageEditorOrUploader
              orderImage={currentImage}
              imageConfig={imageConfig}
              mediaList={mediaList}
              layout={layout}
              onDeleteOrderImage={() => removeImageAtIndex(index)}
              onUpdateOrderImage={newOrderImage =>
                insertImageAtIndex(index, newOrderImage)
              }
              disabled={disableEditing}
              advertiserLogo={advertiserLogo}
            />
          </div>
        );
      })}
    </div>
  );
}
